export default {
    props: {
        validate: { type: Boolean, default: true },
        vfield: { type: String, default: '' },
        vindex: { type: Number, default: null },
        silent: { type: Boolean, default: false }
    },
    computed: {
        invalid () {
            const validator = this.getValidator();
            return validator && validator.$error;
        },
        errorMsg () {
            const validator = this.getValidator();
            if (!this.silent && validator) {
                if (validator.minLength === false) {
                    return `Min ${validator.$params.minLength.min}`;
                } else if (validator.maxLength === false) {
                    return `Max ${validator.$params.maxLength.max}`;
                } else if (validator.numeric === false) {
                    return `Numbers only`;
                } else if (validator.required === false) {
                    return `Field is required`;
                }
            }

            return null;
        }
    },
    methods: {
        touch (e) {
            const validator = this.getValidator();
            if (validator) {
                validator.$touch(e);
            }
        },
        getValidator () {
            if (!this.validate || _.isNil(this.$vnode.data.model)) {
                return null;
            }
            const vmodel = this.vfield ? this.vfield.replace('index', this.vindex) : this.$vnode.data.model.expression;
            return _.get(this.$parent.$options.parent.$v, vmodel, null);
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/wc-validated-mixin.js